var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"80px"},attrs:{"id":"container"}},[_c('BannerTwo',{attrs:{"symbol":_vm.symbol}}),_c('div',{staticClass:"run-section"},[_c('RunTheNumbers')],1),_c('ForArtists',{attrs:{"symbol":_vm.symbol}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }